import { render, staticRenderFns } from "./RoleAndPermissionsAdd.vue?vue&type=template&id=f5b095c8&scoped=true&"
import script from "./RoleAndPermissionsAdd.vue?vue&type=script&lang=js&"
export * from "./RoleAndPermissionsAdd.vue?vue&type=script&lang=js&"
import style0 from "./RoleAndPermissionsAdd.vue?vue&type=style&index=0&id=f5b095c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b095c8",
  null
  
)

export default component.exports